const HOURS_IN_MILLIS = 60 * 60 * 1000;
const RELEASE_FETCH_INTERVAL_HOURS = 12;

export const REMOTE_CONFIG_DEFAULTS = {
  agent_handoff: false,
};

export const MINIMUM_FETCH_INTERVAL_MILLIS = __DEV__
  ? 0
  : RELEASE_FETCH_INTERVAL_HOURS * HOURS_IN_MILLIS;
